import { z } from 'zod';

/**
 * GET /api/v1/billing-enforcement/me — aligned with
 * core-api `BillingEnforcementPolicyResponse` (Pydantic).
 */
export const billingEnforcementStateSchema = z.enum([
  'active',
  'past_due',
  'grace_period',
  'limited_service',
  'suspended',
]);

export const billingWriteModeSchema = z.enum(['normal', 'throttled', 'blocked']);

export const billingUiAccessModeSchema = z.enum(['full', 'read_only', 'billing_export_only']);

export const billingNudgeLevelSchema = z.enum(['none', 'low', 'medium', 'high', 'final']);

export const billingEnforcementPolicyResponseSchema = z.object({
  organization_id: z.string().min(1),
  state: billingEnforcementStateSchema,
  ai_inference_enabled: z.boolean(),
  write_mode: billingWriteModeSchema,
  background_jobs_paused: z.boolean(),
  ui_access_mode: billingUiAccessModeSchema,
  billing_failed_at: z.string().nullable().optional(),
  billing_override_state: billingEnforcementStateSchema.nullable().optional(),
  billing_override_until: z.string().nullable().optional(),
  billing_override_reason: z.string().nullable().optional(),
  delinquent_days: z.number().int().min(0).nullable().optional(),
  nudge_level: billingNudgeLevelSchema.optional().default('none'),
  days_until_suspension: z.number().int().min(0).nullable().optional(),
  nudge_urgent_modal: z.boolean().optional().default(false),
});

export type BillingEnforcementState = z.infer<typeof billingEnforcementStateSchema>;
export type BillingWriteMode = z.infer<typeof billingWriteModeSchema>;
export type BillingUiAccessMode = z.infer<typeof billingUiAccessModeSchema>;
export type BillingNudgeLevel = z.infer<typeof billingNudgeLevelSchema>;
export type BillingEnforcementPolicy = z.infer<typeof billingEnforcementPolicyResponseSchema>;
